import { NgStyle } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'video-background',
  templateUrl: './video-background.component.html',
  styleUrls: ['./video-background.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgStyle],
})
export class VideoBackgroundComponent implements AfterViewInit, OnChanges {
  @Input() public posterImage: string;
  @Input() public videoURLWebm: string;
  @Input() public videoURLMP4: string;
  @Input() public isMute: boolean;
  @Input() public position: 'fixed' | 'absolute' = 'fixed';

  @ViewChild('wrapper') public wrapper: ElementRef<HTMLDivElement>;
  @ViewChild('video') public video: ElementRef<HTMLVideoElement>;

  constructor(private cdr: ChangeDetectorRef) {}

  public ngAfterViewInit() {
    if (this.wrapper) {
      return;
    }

    if (this.video) {
      this.video.nativeElement.poster = this.posterImage;
      return;
    } else {
      this.video.nativeElement.muted = true;
    }
  }

  public muteOnPlay() {
    const video = document.getElementById('video') as HTMLVideoElement;

    if (video) {
      video.muted = true;
      video.play();
    }

    this.cdr.detach();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    const mute = changes.isMute?.currentValue === 'true' ? true : false;
    if (changes?.isMute && this.video) {
      this.video.nativeElement.muted = mute;
    }
  }
}
